// BSL-STU §5 — Stüdyo turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// oncelik: aynı yolda birden çok tur varken hedefi görünüyorsa bu seçilir (Yeni Ürün'de Studio paketi).
export default {
  studioSaat: {
    yol: "/studio/ayarlar",
    sekme: "4",
    adimlar: [
      { hedef: '[data-tur="stu-saat-gun"]', metin: "Stüdyonun açık olduğu günleri seçin." },
      { hedef: '[data-tur="stu-saat-aralik"]', metin: "Açılış ve kapanış saati; dersler bu aralığa göre denetlenir.", kavram: "studioSaat" },
      { hedef: '[data-tur="stu-saat-kaydet"]', metin: "Kaydedin. Tatil günlerini Tatil Günleri sekmesinden ayrıca girin." },
    ],
  },
  studioEgitmen: {
    yol: "/studio/ayarlar",
    sekme: "2",
    adimlar: [
      { hedef: '[data-tur="egitmen-yeni"]', metin: "Eğitmen bir kullanıcıdır; kendinizi de ekleyebilirsiniz. Kullanıcı yoksa önce kullanıcı açılmalı." },
      { hedef: '[data-tur="salon-sekme"]', metin: "«Salon 1» hazır gelir. Adını ve kapasitesini Salonlar sekmesinden değiştirin." },
    ],
  },
  studioDersTip: {
    yol: "/studio/ayarlar",
    sekme: "1",
    adimlar: [
      { hedef: '[data-tur="derstip-not"]', metin: "Ders tipi bir Studio paketidir; yeni tip Ürünler'den Studio paketi olarak açılır.", kavram: "dersTipiPaket" },
      { hedef: '[data-tur="derstip-rozet"]', metin: "«Ürünü yok» rozetli tipe paket satılamaz; ürününü açın." },
    ],
  },
  studioPaket: {
    yol: "/urun/yeniurun",
    oncelik: true,
    adimlar: [
      { hedef: '[data-tur="urun-paket-seans"]', metin: "Pakette kaç ders hakkı var.", kavram: "paketSeans" },
      { hedef: '[data-tur="urun-paket-gun"]', metin: "Paketin kaç gün geçerli olduğu; boş bırakılırsa süresizdir." },
      { hedef: '[data-tur="urun-tum-sube"]', metin: "Açıksa paket her şubenin derslerinde kullanılır.", kavram: "tumSubeler" },
    ],
  },
  studioDersYeni: {
    yol: "/studio/dersyeni",
    adimlar: [
      { hedef: '[data-tur="ders-tip"]', metin: "Ders tipini seçin; katılımcılar bu tipte paketi olan üyelerden seçilir.", kavram: "dersTipiPaket" },
      { hedef: '[data-tur="ders-egitmen-salon"]', metin: "Eğitmen ve salon seçin; aynı saatteki çakışma denetlenir." },
      { hedef: '[data-tur="ders-seri"]', metin: "Her hafta tekrarlayan ders için seri seçin; dersler birlikte açılır." },
    ],
  },
  // STU-YOKLAMA: takvim bu haftanın bir dersini açık getirir (bsl.pencereIstegi = "studioYoklama").
  studioYoklama: {
    yol: "/studio/dashboard",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="katilim-ekle"]', metin: "Üye eklemek için dersi düzenleyin; listede ders tipinde paketi olan üyeler çıkar." },
      { hedef: '[data-tur="katilim-geldi"]', metin: "Ders bitince Geldi ya da Gelmedi işaretleyin. Geldi'de paketten bir ders düşer.", kavram: "yoklama" },
      { hedef: '[data-tur="katilim-tumu"]', metin: "«Tümünü Geldi» hepsini birden işaretler." },
    ],
  },
};
